var _path, _path2, _rect, _rect2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOcMoneyProfits(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 318,
    height: 237,
    viewBox: "0 0 318 237",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1038 211.5C33.5296 164.234 54.9275 141.063 67.7685 134.371C68.9647 133.748 70.2991 133.5 71.6479 133.5H97.9022C99.3524 133.5 100.797 133.799 102.076 134.482C127.257 147.92 134.041 187.125 131.604 211.5C130.604 230.5 117.104 234 105.104 234H64.6035C40.1035 233 38.437 217.667 38.1038 211.5Z",
    fill: "#223B41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8965 173.666C90.7917 172.608 87.5961 171.619 84.6081 171.63M76.9824 200.333C79.148 201.323 81.8982 201.842 84.6081 201.473M84.6081 171.63C81.0069 171.644 77.7073 173.112 76.9824 177.666C76.0263 183.673 83.274 185.829 87.5916 188C93.56 191 93.5056 196.624 89.9125 199.333C88.2965 200.552 86.4617 201.22 84.6081 201.473M84.6081 171.63V167M84.6081 201.473V206",
    stroke: "white",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66.6035,
    y: 122.5,
    width: 35,
    height: 8,
    rx: 4,
    stroke: "#223B41",
    strokeWidth: 5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 128.896,
    y: 54,
    width: 60,
    height: 12,
    rx: 6,
    fill: "#223B41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6035 116.5L58.6035 96.5",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6035 116.5L110.104 96",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1035 96C61.4368 96.6667 68.8035 96.9 71.6035 92.5C74.4035 88.1 78.1035 89.3333 79.6035 90.5L84.1035 94.5",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.104 95.5976C106.77 96.2643 99.4035 96.4976 96.6035 92.0976C93.8035 87.6976 90.1035 88.931 88.6035 90.0976L84.1035 94.5",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132.604 51L114.104 15.5",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M186.104 51L204.104 15",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.104 15.3628C119.873 16.511 132.623 16.9129 137.469 9.33494C142.315 1.75701 148.719 3.88113 151.315 5.89043L159.104 12.7795",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M204.104 14.3628C198.334 15.511 185.584 15.9129 180.738 8.33494C175.892 0.757011 169.488 2.88113 166.892 4.89043L159.104 12.4724",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.28608,
    y: 226.904,
    width: 47.2945,
    height: 11.8004,
    rx: 5.90019,
    transform: "rotate(-61.5197 4.28608 226.904)",
    stroke: "#223B41",
    strokeWidth: 5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 208.604,
    y: 188.5,
    width: 47.2945,
    height: 11.8004,
    rx: 5.90019,
    stroke: "#223B41",
    strokeWidth: 5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 215.604,
    y: 205.5,
    width: 47.2945,
    height: 11.8004,
    rx: 5.90019,
    stroke: "#223B41",
    strokeWidth: 5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 208.604,
    y: 222.5,
    width: 47.2945,
    height: 11.8004,
    rx: 5.90019,
    stroke: "#223B41",
    strokeWidth: 5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 259.604,
    y: 222.5,
    width: 47.2945,
    height: 11.8004,
    rx: 5.90019,
    stroke: "#223B41",
    strokeWidth: 5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 267.604,
    y: 207.5,
    width: 47.2945,
    height: 11.8004,
    rx: 5.90019,
    stroke: "#223B41",
    strokeWidth: 5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 260.604,
    y: 191.5,
    width: 47.2945,
    height: 11.8004,
    rx: 5.90019,
    stroke: "#223B41",
    strokeWidth: 5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 251.604,
    y: 174.5,
    width: 47.2945,
    height: 11.8004,
    rx: 5.90019,
    stroke: "#223B41",
    strokeWidth: 5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 256.604,
    y: 157.5,
    width: 47.2945,
    height: 11.8004,
    rx: 5.90019,
    stroke: "#223B41",
    strokeWidth: 5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M115.396 88C121.396 80.1667 126.604 73.5 137.104 70H182.104C201.437 80.1667 232.896 111 230.896 176.5",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M130.896 231H200.396",
    stroke: "#223B41",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M172.103 134C168.929 132.413 164.11 130.928 159.604 130.946M148.103 173.999C151.369 175.484 155.517 176.264 159.604 175.71M159.604 130.946C154.173 130.966 149.196 133.168 148.103 140C146.661 149.009 157.592 152.244 164.103 155.499C173.104 160 173.022 168.436 167.603 172.5C165.166 174.328 162.399 175.331 159.604 175.71M159.604 130.946V124M159.604 175.71V182.5",
    stroke: "#223B41",
    strokeWidth: 7,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcMoneyProfits);
export default __webpack_public_path__ + "static/media/oc-money-profits.927cd6294e1e1f2f3786fb67a8c4ebfd.svg";
export { ForwardRef as ReactComponent };